"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var material_1 = require("@mui/material");
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var InviteAcceptDecline_1 = __importDefault(require("./InviteAcceptDecline"));
var defaultHeight = 50 + 78; // 50 topbar, 78 buttons
function Invite() {
    var inviteParam = (0, react_router_dom_1.useParams)().inviteId;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var _a = (0, react_1.useState)(defaultHeight), height = _a[0], setHeight = _a[1];
    var topBarRef = (0, react_1.useRef)();
    var _b = (0, react_query_1.useQuery)(['invite', inviteParam], function () {
        return axios_1.default.get("/data/invites/".concat(inviteParam)).then(function (result) { return result.data; });
    }), isLoading = _b.isLoading, invite = _b.data;
    (0, react_1.useEffect)(function () {
        if (!isLoading && invite && topBarRef.current) {
            setHeight(defaultHeight + topBarRef.current.clientHeight);
        }
    }, [isLoading, invite]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {});
    }
    if (!invite) {
        return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: isSmallScreen ? ConnectionStyles_1.containerStyles.containerMobile : ConnectionStyles_1.containerStyles.container }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.topBar }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h5", flexGrow: "1" }, { children: trans_1.default.get('labels.frontend.general.oops') })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.innerContainer }, { children: trans_1.default.get('labels.frontend.invite.does_not_exist') }))] })));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: isSmallScreen ? __assign(__assign({}, ConnectionStyles_1.containerStyles.containerMobile), { height: "calc(100vh - ".concat(height, "px)") }) : ConnectionStyles_1.containerStyles.container }, { children: invite && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ ref: topBarRef, sx: ConnectionStyles_1.containerStyles.topBar }, { children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { src: invite.initiatingUser.profile.profilePicture, alt: invite.initiatingUser.name }), (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h5", flexGrow: "1" }, { children: invite.initiatingUser.name })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "subtitle2" }, { children: invite.initiatingUser.profile.tagline }))] })] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ConnectionStyles_1.containerStyles.innerContainer }, { children: invite.messages && (0, html_react_parser_1.default)(invite.messages.map(function (message) { return message.content; }).join(' ')) })), invite.accepted === null && (0, jsx_runtime_1.jsx)(InviteAcceptDecline_1.default, { invite: invite })] })) })));
}
exports.default = Invite;
